import { IApplicationOption } from './interfaces';

// eslint-disable-next-line import/prefer-default-export
export const getApplicationOption = (
  applicationName: IApplicationOption['value'] | undefined,
): IApplicationOption | null => (applicationName ? {
  label: applicationName,
  value: applicationName,
} : null);
